import React, { useMemo, useState } from "react";

import { makeStyles } from "tss-react/mui";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

import { ButtonUI, KMKDrawer } from "../../../../Common";

const drawerWidth = 420;

const useStyles = makeStyles()((theme) => ({
  heading: {
    color: "#DF672A",
    fontWeight: "bold",
    fontSize: "1rem",
    "& span": {
      fontWeight: "normal",
    },
  },
  closeIcon: {
    padding: 0,
  },
  container: {
    height: "100%",
    padding: "25px 30px",
    "& .errorMessage .MuiPaper-root": {
      marginTop: "20px",
      alignItems: "flex-start",
      border: "none",
    },
    "& .errorMessage .MuiAlert-message": {
      color: "#C72C2C",
    },
    "& .errorMessage": {
      marginBottom: 0,
    },
  },
}));

const AddRelationship = ({ entities, onClose, onSave, relationships }) => {
  const { classes } = useStyles();

  const entityNames = useMemo(() => {
    const sortedEntities = [...entities];
    sortedEntities.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

    return sortedEntities.map(({ id, name }) => ({
      id,
      name,
      added: relationships.some((relEntity) => relEntity === name),
    }));
  }, [entities, relationships]);

  const [entity, setEntitie] = useState("");

  return (
    <KMKDrawer
      anchor="right"
      open={true}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: "450px" },
          boxSizing: "border-box",
        },
      }}
    >
      <Toolbar />
      <Box className={classes.container} role="presentation">
        <Grid container spacing={2}>
          <Grid size={10}>
            <Typography className={classes.heading} variant="h6" gutterBottom component="div">
              Entity Relationship
            </Typography>
          </Grid>
          <Grid size={2}>
            <Button className={classes.closeIcon} onClick={onClose}>
              <CloseIcon />
            </Button>
          </Grid>
        </Grid>

        <>
          <FormControl required fullWidth variant="outlined" sx={{ my: 2 }}>
            <InputLabel>Entity</InputLabel>
            <Select value={entity} onChange={(e) => setEntitie(e.target.value)} label="Entity">
              {entityNames.map((entity) => (
                <MenuItem key={entity.id} value={entity.id} disabled={entity.added}>
                  {entity.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>

        <Box my={2}>
          <ButtonUI variant="contained" color="success" disabled={!entity} onClick={() => onSave(entity)}>
            Add
          </ButtonUI>
          <ButtonUI variant="contained" color="secondary" style={{ marginLeft: 15 }} onClick={onClose}>
            Cancel
          </ButtonUI>
        </Box>
      </Box>
    </KMKDrawer>
  );
};

export default AddRelationship;
